module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/amount-declined/amount-declined.component.html
// module id = ./src/app/components/amount-declined/amount-declined.component.html
// module chunks = main